import { dateStringToDateTime, formatInternalDate } from '~/lib/DateTime.js';
import { format, parse } from 'date-fns';
import QuestionLabel from '~/components/forms/questions/QuestionLabel';
import React from 'react';
import Autocomplete from 'react-google-autocomplete';

const LocationQuestion = ({ label, value, setValue, settings }) => {
    return (
        <label>
            <QuestionLabel label={label} settings={settings} />
            <Autocomplete
                apiKey={'AIzaSyDjbSiaP0DU0QR8_wygE_QK6JEVdssW8LA'}
                onChange={e => setValue(e.target.value)}
                onPlaceSelected={place => setValue(place.formatted_address)}
                value={value || ''}
                options={{
                    types: [],
                }}
                type="text"
            />
        </label>
    );
};

export default LocationQuestion;
